{
  "big_actions": "Main tasks",
  "new_orders_one": "{{count}} new",
  "new_orders_other": "{{count}} new",
  "new_orders_banner_one": "{{count}} new order just arrived",
  "new_orders_banner_other": "{{count}} new orders just arrived",
  "see_orders": "See orders",
  "sound": "Sound for new orders",
  "todo": {
    "title": "To do today",
    "do_it": "Do it",
    "all_done": "Nothing waiting — well done.",
    "could_not_check": "Could not check",
    "retry": "Try again",
    "rows": {
      "bank_transfers_one": "{{count}} bank transfer to check",
      "bank_transfers_other": "{{count}} bank transfers to check",
      "payments_overdue_one": "{{count}} transfer is overdue",
      "payments_overdue_other": "{{count}} transfers are overdue",
      "to_ship_one": "{{count}} order to pack and ship",
      "to_ship_other": "{{count}} orders to pack and ship",
      "pickup_ready_one": "{{count}} order waiting for pickup",
      "pickup_ready_other": "{{count}} orders waiting for pickup",
      "export_missing_evidence_one": "{{count}} overseas order without export proof",
      "export_missing_evidence_other": "{{count}} overseas orders without export proof",
      "returns_one": "{{count}} return to handle",
      "returns_other": "{{count}} returns to handle",
      "flagged_one": "{{count}} order to check",
      "flagged_other": "{{count}} orders to check",
      "no_photos_one": "{{count}} product without pictures",
      "no_photos_other": "{{count}} products without pictures",
      "no_price_one": "{{count}} product without a price",
      "no_price_other": "{{count}} products without a price",
      "unverified_compare_at_one": "{{count}} “was” price without proof",
      "unverified_compare_at_other": "{{count}} “was” prices without proof",
      "prices_to_check_one": "{{count}} product whose price needs a check",
      "prices_to_check_other": "{{count}} products whose price needs a check",
      "sold_twice_one": "{{count}} card sold twice",
      "sold_twice_other": "{{count}} cards sold twice",
      "stock_differences_one": "{{count}} stock difference found",
      "stock_differences_other": "{{count}} stock differences found",
      "old_holds_one": "{{count}} card reserved for more than a day",
      "old_holds_other": "{{count}} cards reserved for more than a day",
      "undelivered_messages_one": "{{count}} message the system could not deliver",
      "undelivered_messages_other": "{{count}} messages the system could not deliver",
      "taxfree_failed_one": "{{count}} tax-free refund failed",
      "taxfree_failed_other": "{{count}} tax-free refunds failed",
      "taxfree_deadline_one": "{{count}} tax-free sale near its 90-day limit",
      "taxfree_deadline_other": "{{count}} tax-free sales near their 90-day limit",
      "taxfree_refund_due_one": "{{count}} tax-free refund to pay",
      "taxfree_refund_due_other": "{{count}} tax-free refunds to pay",
      "payouts_due_one": "{{count}} consigned sale to pay out",
      "payouts_due_other": "{{count}} consigned sales to pay out",
      "kobutsu_incomplete_one": "{{count}} 古物台帳 entry incomplete",
      "kobutsu_incomplete_other": "{{count}} 古物台帳 entries incomplete",
      "shift_variance_one": "{{count}} register difference (過不足) to check",
      "shift_variance_other": "{{count}} register differences (過不足) to check"
    },
    "hints": {
      "bank_transfers": "Customers say they paid — check your bank and confirm (入金確認).",
      "payments_overdue": "The payment date passed — remind the customer or cancel.",
      "to_ship": "Paid orders waiting for preparing and shipping.",
      "pickup_ready": "The customer comes to the shop — hand it over.",
      "export_missing_evidence": "Add the shipping proof so the sale stays tax-free for export.",
      "returns": "Approve, receive or refund.",
      "flagged": "Marked for a second look before shipping.",
      "no_photos": "Customers buy what they can see — add photos.",
      "no_price": "Finish these drafts: condition, price and stock.",
      "unverified_compare_at": "A crossed-out price needs proof (8 weeks / maker price) — fix or remove it.",
      "prices_to_check": "Prices not checked for a long time (red) — open them, check the market and press “Price is still right” or change the price.",
      "sold_twice": "Decide who gets the card and tell the other customer.",
      "stock_differences": "The nightly check found numbers that do not match.",
      "old_holds": "Release them or finish the sale.",
      "undelivered_messages": "Something did not go through — see what happened.",
      "taxfree_failed": "The refund to the tourist did not go through — try again or choose another way.",
      "taxfree_deadline": "Customs confirmation is due within 7 days.",
      "taxfree_refund_due": "Customs confirmed — pay the tax back to the customer.",
      "payouts_due": "Consignors are waiting for their money.",
      "kobutsu_incomplete": "An identity check or a required detail is missing.",
      "shift_variance": "The manager approved a cash difference at closing in the last 7 days."
    },
    "source_error": {
      "payments": "Bank transfers could not be checked.",
      "orders": "Orders could not be checked.",
      "catalog": "Products could not be checked.",
      "conflicts": "Cards sold twice could not be checked.",
      "discrepancies": "Stock differences could not be checked.",
      "holds": "Reserved cards could not be checked.",
      "inbox": "The to-do list could not be checked.",
      "taxfree": "Tax-free refunds could not be checked.",
      "settlements": "Consignor payouts could not be checked.",
      "kobutsu": "The 古物台帳 could not be checked.",
      "pos": "Register shifts could not be checked"
    }
  },
  "kpi": {
    "title": "Numbers",
    "period": "Period",
    "periods": {
      "today": "Today",
      "7d": "7 days",
      "30d": "30 days"
    },
    "error": "Could not load.",
    "sales_web": "Received — website",
    "sales_pos": "Received — shop register",
    "payments_count_one": "{{count}} payment",
    "payments_count_other": "{{count}} payments",
    "orders": "Orders",
    "new_cards": "Cards added",
    "sales_note": "Money received, tax included, as recorded by the payments of each channel."
  },
  "activity": {
    "title": "Recent changes",
    "all": "All changes",
    "error": "The change history could not be loaded.",
    "empty": "No changes yet.",
    "actor": {
      "staff": "Staff",
      "customer": "Customer",
      "system": "System"
    },
    "verb": {
      "created": "added {{what}}",
      "updated": "changed {{what}}",
      "deleted": "removed {{what}}",
      "status": "changed the status of {{what}}",
      "other": "worked on {{what}}"
    },
    "entity": {
      "product": "a product",
      "variant": "a product's item",
      "collection": "a collection",
      "order": "an order",
      "payment": "a payment",
      "refund": "a refund",
      "customer": "a customer",
      "consignor": "a consignor",
      "consignment_item": "a consigned card",
      "settlement": "a settlement",
      "payout": "a payout",
      "unit": "a card in stock",
      "inventory": "stock",
      "staff": "a staff account",
      "role": "a role",
      "tax_setting": "tax settings",
      "setting": "settings",
      "page": "a page",
      "theme": "the website design",
      "discount": "a discount code",
      "record": "a record"
    }
  }
}
